// extracted by mini-css-extract-plugin
module.exports = {"container":"DropdownIndicator_container__2ek7F"};